module.exports = __webpack_public_path__ + "static/img/qrCode.5a5038b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/qrCode.png
// module id = osEU
// module chunks = 1